
export function getPercentage(value: any, total: any) {
  const numValue = Number(value);
  const numTotal = Number(total);

  if (isNaN(numValue) || isNaN(numTotal)) {
    return 0; // invalid input
  }

  const result = (numValue / 100) * numTotal;
  return result;
}
